import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { FeatureFlagsPayload, FeatureFlagsResponse } from '../../models/fund/global-config.model';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagApiService {
  private readonly resourceUrl = '/configuration/frontend/feature-flags';

  constructor(private apiService: ApiService) {}

  getFeatureFlags(): Observable<FeatureFlagsResponse> {
    return this.apiService.get(this.resourceUrl) as Observable<FeatureFlagsResponse>;
  }

  setFeatureFlags(payload: FeatureFlagsPayload): Observable<any> {
    return this.apiService.put(this.resourceUrl, payload);
  }
}
